import * as React from "react";
const SvgAttachment = (props) => (React.createElement("svg", Object.assign({ viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { d: "M5.625 1.871V22.13h9.006l-.004-7.783-.002-7.784h-5.25l-.004 5.532-.002 5.531h1.508v-9.56h2.246v12.557h-6V3.378h9.754v14.246h1.498V1.871H12Z", style: {
            clipRule: "evenodd",
            fill: "currentColor",
            fillRule: "evenodd",
        } })));
export default SvgAttachment;
